import { render, staticRenderFns } from "./speakerDetector.vue?vue&type=template&id=6841bf8d&scoped=true"
import script from "./speakerDetector.vue?vue&type=script&lang=js"
export * from "./speakerDetector.vue?vue&type=script&lang=js"
import style0 from "./index.scss?vue&type=style&index=0&id=6841bf8d&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6841bf8d",
  null
  
)

export default component.exports